/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { usePecField } from 'components/form'
import { PrivateRoute } from 'components/route'
import { useAtendimentoContext } from 'hooks/atendimento-context/useAtendimentoContext'
import { Fragment, useRef } from 'react'
import { useRouteMatch } from 'react-router'
import { NIVEL_SUPERIOR } from 'types/NivelCbo'
import { MetaPath } from 'util/metaPath'

import { CONSULTA_SEGUIMENTO_URL_MODAL } from '../../consulta-seguimento/model-consultaSeguimento'
import { MChatModal } from '../mchat-modal/MChatModal'
import { MCHAT_URL_MODAL, MChatAnteriorFooterInfoModel, MChatFieldModel } from '../model-mchat'
import { MChatFieldAccordionSection } from './MChatFieldAccordionSection'

interface MChatFieldProps {
  name: MetaPath<MChatFieldModel>
  valuesAtendimentoAnterior: MChatFieldModel
  atendimentoAnteriorAtendProfId: ID
  footerInfo?: MChatAnteriorFooterInfoModel
}

export function MChatField(props: Readonly<MChatFieldProps>) {
  const { name, valuesAtendimentoAnterior, atendimentoAnteriorAtendProfId, footerInfo } = props

  const ref = useRef<HTMLDivElement>()
  const match = useRouteMatch()
  const modalMChatUrl = `${match.url}${MCHAT_URL_MODAL}`
  const modalConsultaSeguimentoUrl = `${match.url}${CONSULTA_SEGUIMENTO_URL_MODAL}`

  const {
    atendimentoProfissional: { id: atendProfId },
    cidadao: { id: cidadaoId },
  } = useAtendimentoContext()

  const {
    input: { onChange },
  } = usePecField({ name })

  const handleSave = (values: MChatFieldModel) => {
    onChange(values)
  }

  const handleDelete = () => {
    onChange(null)
  }

  const handleClose = () => {
    setTimeout(() => ref?.current?.focus())
  }

  return (
    <Fragment>
      <div ref={ref} tabIndex={-1} css={styles.root} data-testid='MChatField'>
        <MChatFieldAccordionSection
          name={name}
          valuesAtendimentoAnterior={valuesAtendimentoAnterior}
          atendimentoAnteriorAtendProfId={atendimentoAnteriorAtendProfId}
          modalUrl={modalMChatUrl}
          onDelete={handleDelete}
          footerInfo={footerInfo}
        />
      </div>

      <PrivateRoute cbos={NIVEL_SUPERIOR} path={modalMChatUrl} exact>
        <MChatModal
          name={name}
          atendProfId={atendProfId}
          cidadaoId={cidadaoId}
          isEditing={false}
          modalConsultaSeguimentoUrl={modalConsultaSeguimentoUrl}
          onSave={handleSave}
          onClose={handleClose}
        />
      </PrivateRoute>

      <PrivateRoute cbos={NIVEL_SUPERIOR} path={`${modalMChatUrl}/editar`} exact>
        <MChatModal
          name={name}
          atendProfId={atendProfId}
          cidadaoId={cidadaoId}
          isEditing={true}
          modalConsultaSeguimentoUrl={modalConsultaSeguimentoUrl}
          onSave={handleSave}
          onClose={handleClose}
        />
      </PrivateRoute>
    </Fragment>
  )
}

const styles = {
  root: css`
    outline: none;
  `,
}
